import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTelegramBot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.1795 6.29219H9.217M7.69825 7.81094V4.77344M11.8071 20.3401H13.7634M12.7852 21.3182V19.362M4.39825 15.7839H5.74148M5.07013 16.4557V15.1125M6.67638 20.0333H8.01961M7.34825 20.7052V19.362M21.5962 13.3599H22.9394M22.2675 14.0318V12.6885M14.4889 4.67135H15.8321M15.1608 5.34271V4M21.3998 4.38594C21.9936 4.38594 22.4415 4.90677 22.2019 5.87552L19.2957 19.5734C19.0925 20.5474 18.504 20.7818 17.6915 20.3286L10.7592 15.2089C10.7323 15.1896 10.7104 15.1642 10.6953 15.1347C10.6802 15.1053 10.6723 15.0727 10.6723 15.0396C10.6723 15.0065 10.6802 14.9739 10.6953 14.9445C10.7104 14.915 10.7323 14.8896 10.7592 14.8703L18.7644 7.64115C19.129 7.31823 18.6863 7.16198 18.2071 7.45365L8.16023 13.7922C8.12976 13.8121 8.09517 13.8247 8.05907 13.8292C8.02298 13.8338 7.98632 13.83 7.9519 13.8182L3.68628 12.4693C2.73836 12.1932 2.73836 11.5422 3.89982 11.0786L20.9675 4.49531C21.1031 4.4309 21.2499 4.39373 21.3998 4.38594Z",
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTelegramBot;
